import { Col, Container, Row } from 'reactstrap';
import LoadingAnimation from '../assets/images/loading/loading-animation.gif';

const LOADING = () => {
  return (
    <>
      <div className="loading">
        <Container className="h-100">
          <Row className="h-100">
            <Col className="text-center my-auto">
              <img src={LoadingAnimation} alt="" className="img-fluid" />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default LOADING;